/* eslint-disable */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  ["en-GB"]: {
    translation: {
      insurance_claims: require("./assets/locales/en/insurance_claims.json"),
      insurance_servicing: require("./assets/locales/en/insurance_servicing.json"),
      platform: require("./assets/locales/en/platform.json")
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "en-GB",
  returnEmptyString: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
